import React from 'react'
import {connect} from 'react-redux'
import {Motion, spring} from 'react-motion';
import R from 'ramda'
import Collapse from 'react-collapse'
import {FormattedMessage} from 'react-intl'
import Joyride from 'react-joyride'

import {fromQueryObject} from '../utils/queryObjectMapper'

import executeQuery from '../actions/executeQuery'
import registerTourComplition from '../actions/registerTourComplition'
import toggleMyQueriesModal from '../actions/toggleMyQueriesModal.js'

import Map from './MapWithEstates'
import PreSearchForm from './PreSearchForm'
import SearchForm from './SearchForm'
import Menu from './Menu'
import QueryResultContainer from './QueryResultContainer'
import AppContainer from './AppContainer'

import QuerySummary from './QuerySummary'
import ModifyButton from './ModifyButton'

const tourSteps = [
  {
    title:<FormattedMessage id="Map" defaultMessage="Map"/>,
    text:<FormattedMessage 
      id="We'll show all the result of your search on the map. As you refine your query, you'll notice that the map is full os usefull informations. Like thoses buttons at the top of the map." 
      defaultMessage="We'll show all the result of your search on the map. As you refine your query, you'll notice that the map is full os usefull informations. Like thoses buttons at the top of the map."/>,
    selector:".map-container",
    position:"top",
  },
  {
    title:<FormattedMessage id="Services" defaultMessage="Services"/>,
    text:<FormattedMessage 
      id="In here you'll find usaual services, by clicking on one of them you'll see on the map where is this service compare to you next estate." 
      defaultMessage="In here you'll find usaual services, by clicking on one of them you'll see on the map where is this service compare to you next estate."/>,
    selector:".services",
    position:"right ",
  },
  {
    title:<FormattedMessage id="Map" defaultMessage="Map"/>,
    text:<FormattedMessage 
      id="The administrative region map shows the regions you've selected on the map." 
      defaultMessage="The administrative region map shows the regions you've selected on the map."/>,
    selector:".map",
    position:"right ",
  },
  {
    title:<FormattedMessage id="Points of Interest" defaultMessage="Points of Interest"/>,
    text:<FormattedMessage 
      id="Want to be near a specific address ? Just enter it here and select departure and arrival time, mode of transport, frequency and maximal distance desired. (Tips: You can enter multiple addresses)"/>,
    selector:".poi-entry",
    position:"top-left",
  },
  {
    title:<FormattedMessage id="Price range" defaultMessage="Price range"/>,
    text:<FormattedMessage 
      id="Define you minimal and maximal prices. If you put the cursor on the right edge, we'll search for every estate whose price in over your min price." 
      defaultMessage="Define you minimal and maximal prices. If you put the cursor on the right edge, we'll search for every estate whose price in over your min price."/>,
    selector:".price-range",
    position:"top-left",
  },
  {
    title:<FormattedMessage id="Area range" defaultMessage="Area range"/>,
    text:<FormattedMessage 
      id="Define you minimal and maximal areas. Same as the price field you can do a search with unlimited areas." 
      defaultMessage="Define you minimal and maximal areas. Same as the price field you can do a search with unlimited areas."/>,
    selector:".area-range",
    position:"top-left",
  },
  {
    title:<FormattedMessage id="Estate type" defaultMessage="Estate type"/>,
    text:<FormattedMessage 
      id="Select the type of estate you want to search for. If you are undecided, go ahead and select multiple estate type." 
      defaultMessage="Select the type of estate you want to search for. If you are undecided, go ahead and select multiple estate type."/>,
    selector:".estate-type",
    position:"top-left",
  },
  {
    title:<FormattedMessage id="Bedrooms" defaultMessage="Bedrooms"/>,
    text:<FormattedMessage 
      id="Define the minimal number of bedrooms that you need. For exemple if you select 2 and we know an estate that match all your criterias but with 3 bedrooms we'll show it." 
      defaultMessage="Define the minimal number of bedrooms that you need. For exemple if you select 2 and we know an estate that match all your criterias but with 3 bedrooms we'll show it."/>,
    selector:".bedrooms",
    position:"top-left",
  },
  {
    title:<FormattedMessage id="Bathrooms" defaultMessage="Bathrooms"/>,
    text:<FormattedMessage 
      id="Just like with bedrooms. Did you notice that you can select 'no' bathrooms, usefull if you're looking for a lot only." 
      defaultMessage="Just like with bedrooms. Did you notice that you can select 'no' bathrooms, usefull if you're looking for a lot only."/>,
    selector:".bathrooms",
    position:"top-left",
  },
  {
    title:<FormattedMessage id="Options" defaultMessage="Options"/>,
    text:<FormattedMessage 
      id="Want to be even more precise in your query? Define more options." 
      defaultMessage="Want to be even more precise in your query? Define more options."/>,
    selector:".more-options",
    position:"top-left",
  },
]

const locale = {
  back: <FormattedMessage id='Back' defaultMessage="Back"/>, 
  close: <FormattedMessage id="Close" defaultMessage="Close"/>, 
  last: <FormattedMessage id="Last" defaultMessage="Last"/>, 
  next: <FormattedMessage id="Next" defaultMessage="Next"/>, 
  skip: <FormattedMessage id="Skip" defaultMessage="Skip"/>,
}

class Search extends React.Component {
  componentDidMount(){
    if(this.props.tourCompleted) { return }
    this.joyride.start()
  }
  componentWillReceiveProps(nextProps){
    if(this.props.tourCompleted && !nextProps.tourCompleted){
      this.joyride.start()
    }
  }
  
  render(){
    window.onresize = showModifyButton;

    const {showEstateList, onQuery, location, onTourEnd, onClickMyQueries} = this.props

    const query = fromQueryObject(location.query)

    var app = <AppContainer>
      <div className="content-container">
        <Joyride 
          ref={(c)=> this.joyride = c}
          locale={locale}
          steps={tourSteps}
          type="continuous"
          showStepsProgress={true}
          showSkipButton={true}
          callback={onTourEnd}
          />
        <div className="map-container">
          <Map query={query}/>
        </div> 
          	    

		    <div id="searchForm" className="form-container search-form-container" onScroll={showModifyButton}>
          <ModifyButton/>          

          <div id="search-sub-form" className="collaspe-search-form">
		        <PreSearchForm query={query}/>
		                       
		        <SearchForm query={query}/>

		        <div className="button-container">
		          <div className="button-spacer"/>

		          <button className="btn btn-primary" onClick={onQuery}>
		            <FormattedMessage id="Show" defaultMessage="Show"/>
		          </button>
		          
		          <div className="button-spacer"/>
                  
                  <button className="btn btn-primary" onClick={onClickMyQueries}>
		            <FormattedMessage id="My queries" defaultMessage="My queries"/>
		          </button>
                  
                  <div className="button-spacer"/>

		        </div>
		      </div>
		      <QueryResultContainer/>
		    </div>

      </div>

    </AppContainer>

    return app;

  }
}

const mapStateToProps = state => {
  return {
    showEstateList: state.show.estateList,
    tourCompleted: state.completedTours.search
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onQuery:  _ => {
       dispatch(executeQuery());
    },
    onClickMyQueries: _ => {
       dispatch(toggleMyQueriesModal());
    },
    onTourEnd: action => dispatch(registerTourComplition('search', action))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Search)


const showModifyButton = () => {  
    var searchFormElement = document.getElementById("searchForm");

	  var querySummaryElement = document.getElementsByClassName("query-summary-container")[0];

	  var modifyButtonElement = document.getElementById("modify-button");

    var searchSubFormElement = document.getElementById("search-sub-form");

    if(searchFormElement.scrollTop<searchSubFormElement.offsetHeight && typeof(querySummaryElement))
	  {
		  {/*modifyButtonElement.style.display = "none";*/}
      {/*modifyButtonElement.style.visibility = "hidden";*/}

      modifyButtonElement.style.top='-9999px';
      modifyButtonElement.style.left='-9999px';      
	  }
	  else if(searchFormElement.scrollTop>searchSubFormElement.offsetHeight && typeof(querySummaryElement) != "undefined")
	  {
		  {/*modifyButtonElement.style.display = "block";*/}
      {/*modifyButtonElement.style.visibility = "visible";*/}      

      modifyButtonElement.style.top=searchFormElement.getBoundingClientRect().top + 'px';
      modifyButtonElement.style.left=searchFormElement.getBoundingClientRect().left + 'px';
	  }
}



/** WEBPACK FOOTER **
 ** ./app/components/Search.jsx
 **/